import {combineReducers} from 'redux';
import { routerReducer } from 'react-router-redux';
import AuthReducer from './auth'
import NotificationsReducer from './notifications-reducer';
import GameDefinitionsReducer from "./game-definitions";
import GameInstanceReducer from "./game-instance";
import { combineForms } from 'react-redux-form';
import KnowledgeQuestionsReducer from "./knowledge-questions-reducer";
import StudentGroupsReducer from './student-groups-reducer';
import BonusTasksReducer from './bonus-tasks-reducer';
import CreativeTasksReducer from "./creative-tasks-reducer";
import LeaderboardReducer from "./leaderboard-reducer";
import * as rh from "../../../common/reducer-helpers";
import * as resource from "../actions/resources"
import ThemeReducer from "./theme-reducer";

const allReducers = combineReducers({
    auth: AuthReducer,
    router: routerReducer,
    notifications: NotificationsReducer,
    gameInstance: GameInstanceReducer,
    knowledgeQuestions: KnowledgeQuestionsReducer,
    studentGroups: StudentGroupsReducer,
    bonusTasks: BonusTasksReducer,
    creativeTasks: CreativeTasksReducer,
    forms: combineForms({
        round01form: {
            paramA: ''
        },
        usersRegistration: {
            email: '',
            password: '',
            password_confirmation: ''
        },
        usersPasswordResetRequest: {
            email: ''
        },
        usersPasswordReset: {
            password: '',
            password_confirmation: '',
            reset_password_token: ''
        },
        usersConfirmationResend: {
            email: ''
        },
        usersPasswordChange: {
            current_password: '',
            password: '',
            password_confirmation: ''
        },
        studentGroupCreate: {
            username: '',
            password: ''
        },
        studentGroupUpdate: {
            username: '',
            password: ''
        },
        bonusTaskCreate: {
            text: '',
            attachment: ''
        },
        gameCreate: {
            game_definition_id: 0,
            user: {
                username: '',
                password: '',
                password_confirmation: ''
            },
            game: {
                properties: {
                    captain: '',
                    member_1: '',
                    member_2: '',
                    member_3: '',
                    member_4: '',
                    member_5: '',
                    school: '',
                    class: '',
                }
            }
        },
        usersProfileChange: {
            name: ''
        }
    }, 'forms'),
    game_definitions: rh.crudReducer(resource.MODEL_GAME_DEFINITION, {}),
    game: rh.crudReducer(resource.MODEL_GAME, {}),
    leaderboard: LeaderboardReducer,
    theme: ThemeReducer
});


export default allReducers
